<template>
  <div class="page-container">
      <div class="page-wrapper">
          <div class="wrapper">

            <div class="page-content">
              <div class="tools" v-if="this.isAuthenticated">
                <button class="btn circle large" @click="updateContent(pageData)">
                  <span class="tooltip">Mettre à jour</span><i class="fa fa-refresh"></i>
                </button>
              </div>

          <!-- TITLE -->
              <template v-if="this.isAuthenticated">
                <div class="hr-wrapper" :class="{'title-wrapper': pageType !== 'Home'}">
                  <h1 v-if="loading">
                    <div class="spacer"></div>
                    <clip-loader style="text-align:left" :loading="loading" :color="'black'" :size="'0.8em'"></clip-loader>
                  </h1>
<!--                     <span v-if="pageType !== 'Home' && !loading" class="breadcrumb"><h4>Recherche</h4></span>
 -->                    <div v-if="pageType !== 'Home'" class="spacer"></div>
                    <h1 v-if="pageData.niceTitle" :class="{'site-title': pageType === 'Home'}">
                      <froala :config="titleEditor" v-model="pageData.niceTitle"></froala>
                    </h1>
                </div>
              </template>
              <template v-else>
                <div class="hr-wrapper" :class="{'title-wrapper': pageType !== 'Home'}">
                    <h1 v-if="loading">
                      <div class="spacer"></div>
                      <clip-loader style="text-align:left" :loading="loading" :color="'black'" :size="'0.8em'"></clip-loader>
                    </h1>
<!--                     <span v-if="pageType !== 'Home' && !loading" class="breadcrumb"><h4>Recherche</h4></span>
 -->                    <h1 v-html="pageData.niceTitle" :class="{'site-title': pageType === 'Home'}">
                    </h1>
                </div>
              </template>

              <!-- INTRO + CONTENT-->

              <template v-if="this.isAuthenticated">
                <div style="z-index: 3" class="hr-wrapper" v-if="pageData.introduction">
                  <froalaView v-if="pageData.introduction" v-html="pageData.introduction"></froalaView>
                </div>
              </template>
              <template v-else>

                <div class="hr-wrapper" v-if="pageData.introduction">
                  <froalaView v-if="pageData.introduction" v-html="pageData.introduction"></froalaView>
                </div>
              </template>
              <div class="spacer"></div>

              <!-- RECHERCHE -->
              <div class="search-container" v-if="pageType === 'recherche'">
                
             <div class="list-wrapper clearfix" style="z-index: 5" v-if="viewMode === 'list' && !loading">
                <div class="filters-selector-wrapper sticky">
                    <div class="option-wrapper large d-only">
                      <div class="option-select disabled">
                        <select value="Membre" disabled>
                          <option v-if="lang==='fr'" value="Membre" selected>Membre</option>
                          <option v-else-if="lang==='en'" value="Membre" selected>Member</option>
                        </select>
                      </div>
                    </div>

                  <div class="option-scroller">
                    <template v-if="lang==='fr'">
                    <div class="option-wrapper" v-for="filter in pageData.filtersData">
                      <div class="option-select" :class="{'active': !(filter.default === filter.title)}">
                        <select v-model="filter.title" @mousedown.stop="restoreScroll">
                          <option :value="filter.default" selected>{{filter.default}}</option>
                          <option :value="value.text" v-for="value in filter.values">{{value.text}}</option>
                        </select>
                      </div>
                    </div>
                    </template>
                    <template v-else-if="lang==='en'">
                    <div class="option-wrapper" v-for="filter in pageData.filtersData_en">
                      <div class="option-select" :class="{'active': !(filter.default === filter.title)}">
                        <select v-model="filter.title" @mousedown.stop="restoreScroll">
                          <option :value="filter.default" selected>{{filter.default}}</option>
                          <option :value="value.text" v-for="value in filter.values">{{value.text}}</option>
                        </select>
                      </div>
                    </div>
                    </template>


                  </div>
                </div>


                  <div class="table">
                    <ul>
                      <template v-if="this.isAuthenticated">
                      <li v-for="(residence, index) in filteredList" class="residence" :tag="'li'">
                          <div class="col large">             
                            <router-link class="d-only" :to="{path: residence.membre.linkTo}" :tag="'p'">
                              {{residence.membre.title}}
                            </router-link>
                            <h4 class="m-only">{{residence.membre.title}}</h4>
                            <p v-if="residence.title" class="small">{{residence.title}}</p>
                            <button class="btn circle mini" 
                              @click="function(){ resetFilters(); showDeleteResidenceModal(index)}">
                              <i class="fa fa-trash"></i>
                            </button>
                            <button class="btn circle mini" 
                              @click="function(){ showResidenceModal('edit', index)}">
                              <i class="fa fa-pencil"></i>
                            </button>
                            <div class="spacer"></div>
                          </div>
                          <div class="col">
                            <h4 class="m-only">Type</h4>
                            <p v-for="type in residence.type">{{type.text}}</p>
                          </div>                          
                          <div class="col">
                            <h4 class="m-only">Activité</h4>
                            <p v-for="activite in residence.activite">{{activite.text}}</p>
                          </div>
                          <div class="col">
                            <h4 class="m-only">Séléction</h4>
                            <p v-for="selection in residence.selection">{{selection.text}}</p>
                          </div>
                          <div class="col">
                            <h4 class="m-only">Moyens</h4>
                            <p v-for="moyens in residence.moyens">{{moyens.text}}</p>
                          </div>
                          <div class="col">
                            <h4 class="m-only">Durée</h4>
                            <p v-if="residence.dureeExacte">{{residence.dureeExacte}}</p>
                            <p v-else v-for="duree in residence.duree">{{duree.text}}</p>
                          </div>
                        </li>

                        <button @click="showResidenceModal('new')" class="btn normal" style="width: 100%; text-align: center;"><i class="fa fa-plus"></i>&nbsp;Ajouter une résidence</button>

                      </template>   
                      <template v-else>      
                      <router-link v-for="(residence, index) in filteredList" :to="{path: residence.membre.linkTo}" class="residence" :tag="'li'">

                        <div class="col large">
                          <h4 class="m-only">{{residence.membre.title}}</h4>
                          <p class="d-only">{{residence.membre.title}}</p>
                          <p v-if="residence.title" class="small">{{residence.title}}</p>
                        </div>      
                        <div class="col">
                          <h4 class="m-only">Type</h4>
                          <p v-for="type in residence.type">{{type.text}}</p>
                        </div>  
                        <div class="col">
                          <h4 class="m-only">Activité</h4>
                          <p v-for="activite in residence.activite">{{activite.text}}</p>
                        </div>
                        <div class="col">
                          <h4 class="m-only">Séléction</h4>
                          <p v-for="selection in residence.selection">{{selection.text}}</p>
                        </div>
                        <div class="col">
                          <h4 class="m-only">Moyens</h4>
                          <p v-for="moyens in residence.moyens">{{moyens.text}}</p>
                        </div>
                        <div class="col">
                          <h4 class="m-only">Durée</h4>
                          <p v-if="residence.dureeExacte">{{residence.dureeExacte}}</p>
                          <p v-else v-for="duree in residence.duree">{{duree.text}}</p>
                        </div>

                      </router-link>

                      </template>
                    </ul>
                  </div>
                </div>
                <div v-else="viewMode === 'map'" style="height:1500px">
                </div>

              </div>
            
                </div>
            </div>
          </div>

        <!--  RESIDENCE MODAL-->  
        <Modal :show="residenceModal.show" @close="residenceModal.show = false" style="position:fixed; width:100%" :maskStyle="'width:66%; top:50px'">
          <div>
            <div class="modal-header">
            </div>
            <div class="modal-body">
                <div class="modal-body">
                    
                  <label class="form-label">
                    <h4>Membre associé</h4>
                    <autocomplete class="form-control" v-if="residenceModal.show"
                      source="/api/page/membres?getChildren=true&q="
                      results-property="children"
                      results-display="title"
                      :initial-display="residenceModal.data.membre.title"
                      :initial-value="residenceModal.data.membre.title"
                      @selected="selectedItem">

                    </autocomplete>
                  </label>

                  <label class="form-label">
                    <h4>Nom de la résidence</h4>
                    <input required autofocus v-model="residenceModal.data.title" class="form-control" placeholder="Titre">
                  </label>

                  <label class="form-label modal-filters" v-for="filter in pageData.filtersData">
                    <h4>{{filter.title}}</h4>
                     <vue-tags-input class="form-control" v-if="residenceModal.show"
                        v-model="residenceModal.data[filter.name]['tag']"
                        :placeholder="'Ajoutez puis tapez “Entrée“'"
                        :tags="residenceModal.data[filter.name]"
                        :autocomplete-items="pageData.filtersData[filter.name].values"
                        @tags-changed="newTags => residenceModal.data[filter.name] = newTags"
                      />
                  </label>
                  <label class="form-label">
                    <h4>Durée exacte</h4>
                    <input required autofocus v-model="residenceModal.data.dureeExacte" class="form-control" placeholder="Durée exacte">
                  </label>

              </div>
            </div>
            <div class="modal-footer text-left">
              <div class="spacer"></div>
              <button class="btn normal" @click="residenceModal.show = false">Annuler</button>
              <button class="btn normal" @click="updateResidence(residenceModal.mode)">OK</button>
            </div>
          </div>
        </Modal>
        <!--  DELETE MODAL-->  
        <Modal :show="deleteResidenceModal.show" @close="deleteResidenceModal.show = false" style="position:fixed; width:100%" :maskStyle="'width:40%; top:40%'">
          <div>
            <div class="modal-header">
                <h3>Supprimer cette résidence ?</h3>
            </div>
            <div class="modal-footer text-left">
                <button class="btn normal" @click="deleteResidenceModal.show = false">Annuler</button>
                <button class="btn normal" @click="deleteResidence()">OK</button>
            </div>
          </div>
        </Modal>

      </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import Modal from './UI/Modal'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Autocomplete from 'vuejs-auto-complete'
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: 'Page',
  components: {
    Modal,
    ClipLoader,
    Autocomplete,
    VueTagsInput
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'userAuthenticated'
    ]),
    pageType () {
      if (this.$route.name === 'Home') {
        return 'Home'
      } else if (this.$route.name === 'Page') {
        return 'page'
      } else if (this.$route.name === 'Membre') {
        return 'membre'
      } else if (this.$route.name === 'Recherche') {
        return 'recherche'
      }
    },
    filteredList() {

        if (this.lang === 'fr'){
        var vm = this
        if (this.pageData.residencesData && this.pageData.filtersData) {
          var typeFilter = 
            { default: this.pageData.filtersData.type.default, selected: this.pageData.filtersData.type.title}        
          var selectionFilter = 
            { default: this.pageData.filtersData.selection.default, selected: this.pageData.filtersData.selection.title} 
          var activiteFilter = 
            { default: this.pageData.filtersData.activite.default, selected: this.pageData.filtersData.activite.title}         
          var moyensFilter = 
            { default: this.pageData.filtersData.moyens.default, selected: this.pageData.filtersData.moyens.title} 
          var dureeFilter = 
            { default: this.pageData.filtersData.duree.default, selected: this.pageData.filtersData.duree.title} 

            return vm.pageData.residencesData.filter(function(residence){
              return (selectionFilter.selected === selectionFilter.default || checkIfValueExist(residence.selection, selectionFilter.selected)) && (dureeFilter.selected === dureeFilter.default || checkIfValueExist(residence.duree, dureeFilter.selected)) && (activiteFilter.selected === activiteFilter.default || checkIfValueExist(residence.activite, activiteFilter.selected)) && (typeFilter.selected === typeFilter.default || checkIfValueExist(residence.type, typeFilter.selected)) && (moyensFilter.selected === moyensFilter.default || checkIfValueExist(residence.moyens, moyensFilter.selected))

            })
        }
        }else if (this.lang === 'en'){
        var vm = this
        if (this.pageData.residencesData_en && this.pageData.filtersData_en) {
          var typeFilter = 
            { default: this.pageData.filtersData_en.type.default, selected: this.pageData.filtersData_en.type.title}        
          var selectionFilter = 
            { default: this.pageData.filtersData_en.selection.default, selected: this.pageData.filtersData_en.selection.title} 
          var activiteFilter = 
            { default: this.pageData.filtersData_en.activite.default, selected: this.pageData.filtersData_en.activite.title}         
          var moyensFilter = 
            { default: this.pageData.filtersData_en.moyens.default, selected: this.pageData.filtersData_en.moyens.title} 
          var dureeFilter = 
            { default: this.pageData.filtersData_en.duree.default, selected: this.pageData.filtersData_en.duree.title} 

            return vm.pageData.residencesData_en.filter(function(residence){
              return (selectionFilter.selected === selectionFilter.default || checkIfValueExist(residence.selection, selectionFilter.selected)) && (dureeFilter.selected === dureeFilter.default || checkIfValueExist(residence.duree, dureeFilter.selected)) && (activiteFilter.selected === activiteFilter.default || checkIfValueExist(residence.activite, activiteFilter.selected)) && (typeFilter.selected === typeFilter.default || checkIfValueExist(residence.type, typeFilter.selected)) && (moyensFilter.selected === moyensFilter.default || checkIfValueExist(residence.moyens, moyensFilter.selected))

            })
        }

        }
    }
  },
  props: {
    viewModeProp: true,
    lang:true
  },
  data () {
    return {
      viewMode: this.viewModeProp,
      loading: true,
      pageData: {},
      deleteNewsItemModal: {
        show: false,
        index: 0
      },
      archiveNewsItemModal: {
        show: false,
        index: 0
      },
      residenceModal: {
        mode: '',
        show: false,
        index: 0,
        data: {
        }
      },
      editModalData: '',
      deleteResidenceModal: {
        show : false,
        index: 0
      },
      titleEditor: {
        toolbarInline: true,
        language: 'fr',
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        toolbarButtons: [''],
        charCounterCount: false,
        htmlDoNotWrapTags: ['h1'],
        paragraphFormat: {
          H1: 'Heading 1'
        },
        paragraphFormatDefaultSelection: 'Heading 1'
      },
      introEditor: {
        toolbarInline: true,
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        language: 'fr',
        imagePaste: false,
        toolbarButtons: ['bold', 'italic', 'superscript', 'insertLink'],
        quickInsertButtons: [],
        imageResize: false,
        paragraphFormat: {
          N: 'Normal'
        },
        paragraphMultipleStyles: false,
        charCounterCount: false
      },
      contentEditor: {
        toolbarInline: true,
        key: 'FE3F1G2B2uB5A2A1C3A5F1G4E1J4A16htdckA-8tiynwA-13eoafH3ct==',
        language: 'fr',
        imagePaste: false,
        toolbarButtons: ['bold', 'italic', 'superscript', 'paragraphFormat', 'paragraphStyle', '|', 'insertImage', 'insertVideo', 'insertFile', 'insertLink', '|', 'clearFormatting'],
        quickInsertButtons: [],
        imageResize: false,
        fileUseSelectedText: true,
        paragraphFormat: {
          N: 'Normal',
          H4: 'Titre'
        },
        paragraphStyles: '',        
        quickInsertButtons: ['image', 'video', 'file', 'link'],
        imageEditButtons: ['imageReplace', 'imageRemove'],
        imageResize: false,
        paragraphMultipleStyles: false,
        charCounterCount: false,
        imageUploadURL: '/api/image',
        fileUploadURL: '/api/file',
        fileMaxSize: 20000000,
        imageUploadParams: {maxSize: 1100},
        requestHeaders: {
          Authorization: `Bearer ${localStorage.getItem('user-token')}`
        },
        imageDefaultWidth: 0
      }

    }
  },
  methods: {
    getContent () {
      this.loading = true
      var url = '/recherche'
      this.pageData = {
        introduction:'',
        content:'',
        sideContent:''
      }
      return new Promise(function (resolve, reject) {
        axios.get('/api/page' + url).then(response => {
          function isJson (str) { try { JSON.parse(str) } catch (e) { return false } return true }
          var pageDataObj = response.data
          Object.keys(pageDataObj).forEach(function (key) {
            if (isJson(pageDataObj[key])) {
              pageDataObj[key] = JSON.parse(pageDataObj[key])
            }
          })
          this.pageData = pageDataObj
          if (this.viewMode === 'map'){
            axios.get('/api/page/membres?getChildren&sort=name').then(response => {
              const mapMembres = response.data.children
              console.log(mapMembres)
              const location = {"long":5.623591436505535,"lat":43.59222375175534,"zoom":5.6}
              this.$emit('refreshMap', { pageType: this.pageType, location: location, mapMembres: mapMembres })
            })
            if (lang === 'fr') {
              this.pageData.niceTitle = "Carte du réseau"
            }
            else if (lang === 'en') {
              this.pageData.niceTitle = "Network map"
            }

          }else{
            const location = { "long" : 1.8213522796947927, "lat" : 47.1674252033753, "zoom" : 11 }
            this.$emit('refreshMap', { pageType: this.pageType, location: location })
          }
          this.populateFilters()
          resolve()
          this.loading = false
        })
        .catch(error => {
          reject(error)
        })
      }.bind(this))
    },
    updateContent (params) {
      var url = '/recherche'
      if (this.pageType === 'Membre') {
        this.pageData.location = {
          long: map.getCenter().lng,
          lat: map.getCenter().lat,
          zoom: map.getZoom()
        }
      }
      console.log(this.pageData.location)
      var pageDataObj = {}

      Object.keys(this.pageData).forEach(function (key) {
        if (typeof this.pageData[key] === 'object' || typeof this.pageData[key] === 'array') {
          var stringifiedKey = JSON.stringify(this.pageData[key])
          pageDataObj[key] = stringifiedKey
        }else{
          pageDataObj[key] = this.pageData[key]
        }
      }.bind(this))
      return new Promise(function (resolve, reject) {
        axios.put('/api/page' + url, pageDataObj).then(response => {
          this.$notify({title: 'La page est à jour !'})
          resolve()
        })
        .catch(error => {
          this.$notify({title: this.pageData.niceTitle, text: error.data})
          reject(error)
        })
      }.bind(this))
    },
    orderingList() {
      if (this.lang === 'fr'){
      function compare(a,b) {if (a.membre.title < b.membre.title) return -1; if (a.membre.title > b.membre.title) return 1; return 0; }
      return this.pageData.residencesData.sort(compare)
      }else if (lang === 'en'){
      function compare(a,b) {if (a.membre.title < b.membre.title) return -1; if (a.membre.title > b.membre.title) return 1; return 0; }
      return this.pageData.residencesData_en.sort(compare)
      }
    },
    populateFilters () {

      function isJson (str) { try { JSON.parse(str) } catch (e) { return false } return true }
      if (this.lang === 'fr'){
      var filterList = this.pageData.filtersData
      var residencesData = this.pageData.residencesData
      } else if  (this.lang === 'en'){
      var filterList = this.pageData.filtersData_en
      var residencesData = this.pageData.residencesData_en
      }
      var residenceModalDataFilters = []
      Object.values(filterList).forEach( function(filterKey) {
        filterKey['values'] = []
        filterKey['title'] = filterKey['default']
        Object.values(residencesData).forEach(function (key) {
          var valuesToPush = key[filterKey['name']]
          var valuesList = filterKey['values']
          console.log(valuesToPush)
          if (typeof valuesToPush === 'object') {
            Object.keys(valuesToPush).forEach( function(key){
              var existAlready = valuesList.map(function(e) { return e.text; }).indexOf(valuesToPush[key].text)
              existAlready === -1 ? valuesList.push({'text': valuesToPush[key].text}) : console.log("This item already exists")
            })
          }else{
            if (typeof valuesToPush != "undefined") {
              if (valuesToPush !== "") {
                valuesList.indexOf(valuesToPush) === -1 ? valuesList.push(valuesToPush) : console.log("This item already exists")
              }
            }
          }
        })
      }.bind(this))
    },
    resetFilters () {
      Object.values(this.pageData.filtersData_en).forEach( function(filterKey) {
        filterKey['title'] = filterKey['default']
      }.bind(this))
    },
    showResidenceModal (mode, index) {
      this.residenceModal.mode = mode
      if (mode === "new") {
          this.residenceModal.index = this.pageData.residencesData.length + 1
          this.residenceModal.data.title = ''
          this.residenceModal.data['membre'] = []
          this.residenceModal.data['selection'] = []
          this.residenceModal.data['duree'] = []
          this.residenceModal.data['dureeExacte'] = []
          this.residenceModal.data['moyens'] = []
          this.residenceModal.data['activite'] = []
          this.residenceModal.data['type'] = []   
        // rebuilt dataset

      }else if (mode === "edit"){
        this.residenceModal.index = index
        this.editModalData = JSON.parse(JSON.stringify(this.filteredList[index]))
        this.residenceModal.data = this.editModalData
      }
      this.residenceModal.show = true
    },
    updateResidence (mode) {
      var index = this.residenceModal.index
      if (this.residenceModal.data.membre.title === ''){
        alert("Vous devez séléctionner un membre")
      }else{
        if (mode === "new") {
          this.residenceModal.data.id = global.newUID()
          var resObj = JSON.parse(JSON.stringify(this.residenceModal.data))
          this.pageData.residencesData.push(resObj)
        } else if (mode === "edit"){
          var elementToEdit = this.pageData.residencesData.find(item => item.id === this.editModalData.id)
          console.log(JSON.stringify(this.elementToEdit))
          console.log(JSON.stringify(this.editModalData))
          elementToEdit.title = this.editModalData.title
          elementToEdit.membre = this.editModalData.membre
          elementToEdit.selection = this.editModalData.selection
          elementToEdit.duree = this.editModalData.duree
          elementToEdit.dureeExacte = this.editModalData.dureeExacte
          elementToEdit.moyens = this.editModalData.moyens
          elementToEdit.activite = this.editModalData.activite
          elementToEdit.type = this.editModalData.type
        }
        this.populateFilters()
        this.orderingList()
        this.residenceModal.show = false
      }
    },
    showDeleteResidenceModal (index) {
      this.deleteResidenceModal.show = true
      this.deleteResidenceModal.index = index
    },
    deleteResidence () {
      this.pageData.residencesData.splice(this.deleteResidenceModal.index, 1)
      this.populateFilters()
      this.deleteResidenceModal.show = false
    },
    selectedItem (object) {
      this.residenceModal.data['membre'] = {
        title: object.selectedObject.title,
        linkTo: object.selectedObject.url,
        location: object.selectedObject.location
      }
    },
    switchView(mode)  {
      this.viewMode = mode
      this.getContent()
    },
    restoreScroll() {
      var scroll = $(window).scrollTop()
      setTimeout( function(){
        $(window).scrollTop(scroll)
        }, 10)
    }
  },
  created () {
    this.getContent().then(response => {
      console.log('Content Loaded')
    })
  },
  watch: {
    $route () {
      this.getContent().then(response => {
        console.log('Content Loaded')
      })
      this.getContent().then(response => {
        console.log('Content Loaded')
      })
      if (app.$route.path.split('/')[1] == 'en'){
        global.lang = 'en'
      }else{
        global.lang = 'fr'
      }
      this.lang = global.lang

    },
    viewModeProp: function(newVal, oldVal) { // watch it
      console.log('Prop changed: ', newVal, ' | was: ', oldVal)
      this.viewMode = newVal
    }
  }
}
</script>

<style lang="scss">

.item {
  height: 100%;
}

.vue-grid-item{
  transition: 0s !important;
}

.vue-grid-item.vue-draggable-dragging {
    opacity: 0.5;
}

.vue-grid-item.vue-grid-placeholder {
  background: yellow;
}
.search-container {
    margin-top: -24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Search.vue